import { shallowEqual, useSelector } from "react-redux"

import type { IRootState } from "../store"

import { APP_REDUCER_NAME, type IAppState } from "./app.slice"

const selector: (state: IRootState) => IAppState = (state: IRootState): IAppState => state[APP_REDUCER_NAME]

function useAppSelector(): IAppState {
    return useSelector(selector, shallowEqual)
}

export { useAppSelector }
